import { put, fork, select, take } from 'redux-saga/effects';

import {
    receiveCartItems,
    RECEIVE_CART_ITEMS
} from '../actions/initialActions';

import { getCartRoute } from '../../../core/js/utils/apiRoutes';
import { debug } from '../utils/logger';

import { tryCatchSaga } from './tryCatchSagas';

export function* requestCartItemsSaga() {
    debug('Saga: requestCartItemsSaga initialized');
    const state = yield select();
    const route = getCartRoute(state);
    const requestOptions = {
        successSaga: requestCartItemsSagaSuccessSaga,
        failSaga: requestCartItemsSagaFailureSaga
    };
    yield fork(tryCatchSaga, route, requestOptions);
}

export function* requestCartItemsSagaSuccessSaga(response, route, options) {
    yield put(receiveCartItems(response));
}

export function* requestCartItemsSagaFailureSaga(error, route, options) {
    Raven.captureException(error, {
        route: route
    });
    yield put(receiveCartItems({ meta: null }));
}

export function* saveDYDiscountableSubtotalSaga() {
    let action;

    while (action = yield take(RECEIVE_CART_ITEMS)) {
        if (!window.DYCS) {
            return;
        }
        const state = yield select();
        window.DYCS.discountableSubtotal = _.get(state, 'core.cart.discountableSubtotal', 0);
    }
}

export default [
    saveDYDiscountableSubtotalSaga
];
